(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/routes.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/routes.js');
"use strict";


setGlobal('svs.ticketsOrderHome.routes', {
  DIVIDER: '/',
  SUBSCRIPTION: {
    CHOOSE: '/prenumeration',
    CONFIRMATION: '/prenumeration/bekraftelse'
  },
  ORDER_HOME: {
    CHOOSE: '/kop-lotter',
    RECEIVER: '/kop-lotter/mottagare',
    MESSAGE: '/kop-lotter/meddelande',
    PREVIEW_COVERLETTER: '/kop-lotter/kontrollera',
    PREVIEW: '/kop-lotter/forhandsgranska',
    CONFIRMATION: '/kop-lotter/bekraftelse/:referenceId?'
  }
});

 })(window);